import { render, staticRenderFns } from "./CreateFillerBetaPdf.vue?vue&type=template&id=28120afe&"
import script from "./CreateFillerBetaPdf.vue?vue&type=script&lang=ts&"
export * from "./CreateFillerBetaPdf.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports